var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    attrs: {
      "name": "patternMaker",
      "pivotY": 0.15,
      "width": "75%",
      "height": "auto",
      "scrollable": true,
      "click-to-close": false,
      "classes": ['generic-modals', 'v--modal', 'patternmaker']
    }
  }, [_c('section', {
    staticClass: "patternmaker-wrapper content modal-scroll-area"
  }, [_c('div', [_c('div', {
    staticClass: "patternmaker-top-nav"
  }, [_c('div', {
    staticClass: "patternmaker-top-nav-logo"
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.assetsPath, "/images/common/customs_logo_red.png"),
      "alt": ""
    }
  })]), _c('div', [_c('h3', {
    staticClass: "patternmaker-top-nav-title"
  }, [_vm._v(_vm._s(_vm.translations.customPatternMakerTitle))])])]), _c('patternmaker-view', {
    on: {
      "disableStatus": _vm.setDisableStatus
    }
  }), _c('div', {
    attrs: {
      "slot": "top-right"
    },
    slot: "top-right"
  }, [_c('button', {
    staticClass: "patternmaker-top-nav-close",
    attrs: {
      "disabled": _vm.disableStatus,
      "title": "Close",
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }